import { type CardVariant } from '@s4l/ds'
import { type Price as ModelPrice } from '@s4l/stayforlong/kernel/Price'
import { type Property } from '@s4l/stayforlong/property/domain/Property'
import { createContext } from 'react'

interface PropertyCardContextType {
  variant: CardVariant
  price: ModelPrice | undefined
  property: Property | undefined
  isSmallCardVariant: boolean
  isSoldOut: boolean
}

export const PropertyCardContext = createContext<PropertyCardContextType>({
  variant: 'default',
  price: undefined,
  property: undefined,
  isSmallCardVariant: false,
  isSoldOut: false,
})
